import React, {useEffect, useMemo} from 'react';
import {useStore} from '@nanostores/react';
import {Helmet} from 'react-helmet';
import {useLocation} from 'react-router';
import {SnackbarProvider} from 'notistack';
import {createTheme, CssBaseline, ThemeProvider} from '@mui/material';
import {QueryClientProvider} from '@tanstack/react-query';
import {LoaderProvider} from './components/Loader.js';
import {ModalComp} from './components/Modals.js';
import {JobsWebSocketProvider} from './util/jobs_websocket.js';
import {$queryClient} from './util/react_query.js';
import {useSiteRoutes} from './routes.js';
import {LIGHT_THEME} from './theme.js';
import {TitleProvider} from './title.js';
import RoutesWrapper from './components/RoutesWrapper.js';
import EnvBadge from './components/EnvBadge.js';
import {ProxyOverlay} from './components/ProxyUsers.js';
import CookiesDisclaimer from './components/CookiesDisclaimer.js';
import {EmailVerificationProvider} from './util/email_verification.js';
import {getEnv} from './util.js';
import './App.css';

const theme = createTheme(LIGHT_THEME);

const App = ()=>{
    let {pathname} = useLocation();
    useEffect(()=>{ window.scrollTo(0, 0); }, [pathname]);
    useEffect(()=>{
        window.theme = ()=>theme;
        return ()=>{ delete window.theme; };
    }, []);
    let routes = useSiteRoutes();
    let queryClient = useStore($queryClient);
    let appEnv = useMemo(()=>getEnv(), []);
    return <React.Fragment>
      {appEnv!='PRD'&&<Helmet>
        <meta name="robots" content="noindex"/>
      </Helmet>}
      <CssBaseline/>
      <QueryClientProvider client={queryClient}>
        <TitleProvider defaultTitle="סימונה צ'רי">
          <ThemeProvider theme={theme}>
            <SnackbarProvider anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}>
              <JobsWebSocketProvider>
                <LoaderProvider>
                  <EmailVerificationProvider>
                    <RoutesWrapper>
                      {routes}
                      <CookiesDisclaimer/>
                    </RoutesWrapper>
                  </EmailVerificationProvider>
                </LoaderProvider>
              </JobsWebSocketProvider>
              <ModalComp/>
            </SnackbarProvider>
            <EnvBadge/>
            <ProxyOverlay/>
          </ThemeProvider>
        </TitleProvider>
      </QueryClientProvider>
    </React.Fragment>;
};

export default App;
